import { memo } from "react";
import {
    DataGridPremium,
    type GridRowParams,
    type GridEventListener
} from '@mui/x-data-grid-premium';
import Box, { type BoxProps } from "@mui/material/Box";
import { when } from "util/support";
import { useModal, withSx } from "ui/atoms/Modal";
import Loader from "ui/molecules/Loader";
import { BasicDialog } from "ui/molecules/Dialog";
import When from "ui/support/When";
import { useRepositoryContext } from "../Repository";
import { Column, type HistoryRecord, type HistoryRepository } from "./repository";
import { useChange, useColumns } from "./support";
import Diff from "./Diff";

const History = (props: BoxProps) => {
    const { rowHasChange } = useChange();

    const {
        open,
        context,
        onOpen,
        onClose
    } = useModal<GridRowParams<HistoryRecord>>();

    const repository = useRepositoryContext<HistoryRepository>();

    const {
        withAvailableColumns,
        getScalarColumns,
        getPinnedColumns
    } = useColumns();

    const onRowClick: GridEventListener<'rowClick'> = rowParams => (
        when(
            rowHasChange(rowParams),
            () => onOpen(rowParams)
        )
    );

    const columns = withAvailableColumns(
        getScalarColumns,
        repository.columns
    );

    return (
        <Box
            {...props}
        >
            <DataGridPremium
                disableSelectionOnClick
                loading={repository.isRepositoryLoading}
                columns={columns}
                rows={repository.data}
                getRowId={({ _id }) => _id}
                onRowClick={onRowClick}
                pinnedColumns={{
                    right: getPinnedColumns(columns)
                }}
                initialState={{
                    columns: {
                        columnVisibilityModel: {
                            [Column.UpdatedAt]: false
                        }
                    }
                }}
            />
            <BasicDialog
                isOpen={open}
                onClose={onClose}
                titleSlot={(
                    <>
                    </>
                )}
                DialogProps={withSx({
                    maxWidth: '80%',
                })}
            >
                <When
                    if={Boolean(context)}
                    then={() => (
                        <Diff
                            {...context!}
                        />
                    )}
                >
                    <Loader
                        isLoading
                        sx={{
                            display: 'grid',
                            placeContent: 'center',
                            height: '100vh',
                            width: '100%'
                        }}
                    />
                </When>
            </BasicDialog>
        </Box>
    );
};

export default memo(History);
